import { render, staticRenderFns } from "./list_item_description.vue.js?vue&type=template&id=225ae83c!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list_item_description.vue?vue&type=template&id=225ae83c"
import script from "./list_item_description.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list_item_description.vue?vue&type=script&lang=js"
export * from "./list_item_description.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list_item_description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('225ae83c')) {
      api.createRecord('225ae83c', component.options)
    } else {
      api.reload('225ae83c', component.options)
    }
    module.hot.accept("./list_item_description.vue.js?vue&type=template&id=225ae83c!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list_item_description.vue?vue&type=template&id=225ae83c", function () {
      api.rerender('225ae83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/resource_lists/list_item_description.vue"
export default component.exports